import styled from 'styled-components';
import {media} from '../../../../../../styles/Qtheme';
import {Link} from 'react-router-dom';

export const Container = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${({theme}) => theme.body};
    position: fixed;
    top: 50px;
    left: 0;
    display: block;
    z-index: 999999 !important;
    overflow-y: scroll;
    padding-bottom: 180px;
    padding-top: 20px;

    border-top: 1px solid ${({theme}) => theme.p2pBorder};

    @media ${media.desktop} {
        margin-top: 40px;
    }

    @media ${media.mobile} {
        margin-top: 0;
    }

`;

export const SearchBox = styled.div`
    width: 100%;
    margin-top: 12px;
    padding: 0 20px;
`;

export const SearchInput = styled.div`
    width: 100%;
    height: 42px;
    background-color: ${({theme}) => theme.itemBg};
    outline: none;
    border: none;
    font-size: 20px;
    font-weight: 400;
    color: ${({theme}) => theme.text};
    padding: 11px 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-family: "Pretendard", sans-serif;

    input {
        width: 100%;
        flex: 1;
        border: none;
        background-color: transparent;
        outline: none;
        font-size: 15px;
        font-weight: 500;
        color: ${({theme}) => theme.text};

        &::placeholder {
            color: ${({theme}) => theme.text};
        }
    }

    span {
        margin-top: -2px;
    }
`;

export const MobileMenuList = styled.ul`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    padding: 0 20px;
    margin-top: 20px;
`;

export const Line = styled.div`
    width: calc(100% - 32px);
    height: 2px;
    margin: 0 auto;
    background-color: #e8e8e8;
    margin-bottom: 24px;
`;

export const MobileThemeMenu = styled.ul`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    li {
        width: 100%;
        padding: 18px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    p {
        font-size: 18px;
        font-weight: 700;
        color: ${({theme}) => theme.text};
    }
`;

export const MenuBtnContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 8px;
    padding: 0 20px;
`;

export const MobileLoginBtn = styled(Link)`
    width: 100%;
    height: 36px;
    border: 1.5px solid ${({theme}) => theme.p2pBorder};
    font-size: 15px;
    font-weight: 500;
    color: ${({theme}) => theme.text};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const MobileSignUpBtn = styled(Link)`
    width: 100%;
    height: 36px;
    font-size: 15px;
    font-weight: 500;
    color: ${({theme}) => theme.primary};
    border: 1.5px solid #F879434D;
    background: #F879431A;
    display: flex;
    justify-content: center;
    align-items: center;
`;
